// extracted by mini-css-extract-plugin
export default {"defaultFontFamily":"Nunito Sans,sans-serif","h1FontFamily":"Anton,sans-serif"};